import axios from 'axios';
import { DEV_IDENTITY_HEADER, getDevIdentityEmail } from './devIdentity';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Alleen lokaal: laat de server weten als we de app even als een ander
    // testaccount willen bekijken. De server accepteert dit uitsluitend in de
    // ontwikkelstand en alleen voor adressen die daar zijn toegestaan.
    const devIdentity = getDevIdentityEmail();
    if (devIdentity) {
      config.headers[DEV_IDENTITY_HEADER] = devIdentity;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/** Nederlandse melding bij een 403, zodat schermen die direct kunnen tonen. */
export const permissionMessage = (error: unknown): string | null => {
  const response = (error as { response?: { status?: number; data?: { message?: string; error?: string } } })
    ?.response;
  if (response?.status !== 403) return null;
  return (
    response.data?.message ||
    response.data?.error ||
    'Hier heb je geen rechten voor. Vraag de superadmin om je toe te voegen.'
  );
};

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      // Redirect to home page
      window.location.href = '/';
    }
    // Een 403 betekent "wel ingelogd, maar geen rechten". Uitloggen zou dan
    // verwarrend zijn; de schermen tonen zelf een uitleg.
    return Promise.reject(error);
  }
);

export default apiClient;
